export default __webpack_public_path__ + "static/media/VI.370f5f4e.svg";